export const getInitials = (name: string) => {
  if (!name) return
  const nameWords = name.split(" ")
  if (nameWords.length < 2) return name[0]

  return `${name[0]}${nameWords[1][0]}`
}
